export enum IconType {
  PrimeIcon = "Prime Icons",
  FontAwesome = "Font Awesome",
}
